module.exports = __webpack_public_path__ + "img/newLogo.0a5906ca.png";